import type { WShopLatestProductsTranslations } from "./pl";

export const en: WShopLatestProductsTranslations = {
  title: "Latest products",
  showAll: "See all",
  noProducts: "No products.",
};
